// export * from './lib/greco-scaffolding-ui-welcome.module';

export * from './lib/welcome.module';
